import React from 'react';
import './DiscoverLoadingScreen.css';

const DiscoverLoadingScreen = () => {
  
  return (
    <div className="discover-loading-screen">
      {/* Header Skeleton */}
      <header className="discover-loading-header">
        <div className="discover-loading-header-content">
          <div className="discover-loading-logo">
            <div className="discover-loading-logo-text"></div>
          </div>
          <div className="discover-loading-header-actions">
            <div className="discover-loading-search-btn"></div>
            <div className="discover-loading-profile-btn"></div>
          </div>
        </div>
        
        {/* Navigation Tabs Skeleton */}
        <div className="discover-loading-nav-tabs">
          <div className="discover-loading-nav-tab active"></div>
          <div className="discover-loading-nav-tab"></div>
          <div className="discover-loading-nav-tab"></div>
          <div className="discover-loading-nav-tab"></div>
        </div>
      </header>

      {/* Main Content Skeleton */}
      <main className="discover-loading-main">
        {/* Featured Creators Section */}
        <section className="discover-loading-section">
          <div className="discover-loading-section-header">
            <div className="discover-loading-section-title"></div>
          </div>
          <div className="discover-loading-featured-container">
            <div className="discover-loading-featured-card"></div>
            <div className="discover-loading-featured-card"></div>
            <div className="discover-loading-featured-card"></div>
          </div>
        </section>

        {/* All Creators Section */}
        <section className="discover-loading-section">
          <div className="discover-loading-section-header">
            <div className="discover-loading-section-title"></div>
            <div className="discover-loading-see-all"></div>
          </div>
          <div className="discover-loading-all-creators-container">
            <div className="discover-loading-creator-card"></div>
            <div className="discover-loading-creator-card"></div>
            <div className="discover-loading-creator-card"></div>
            <div className="discover-loading-creator-card"></div>
          </div>
        </section>

        {/* Categories Section */}
        <section className="discover-loading-section">
          <div className="discover-loading-section-header">
            <div className="discover-loading-section-title"></div>
            <div className="discover-loading-see-all"></div>
          </div>
          <div className="discover-loading-categories-grid">
            <div className="discover-loading-category-card"></div>
            <div className="discover-loading-category-card"></div>
            <div className="discover-loading-category-card"></div>
            <div className="discover-loading-category-card"></div>
            <div className="discover-loading-category-card"></div>
            <div className="discover-loading-category-card"></div>
          </div>
        </section>

        {/* Recommended Section */}
        <section className="discover-loading-section">
          <div className="discover-loading-section-header">
            <div className="discover-loading-section-title"></div>
            <div className="discover-loading-refresh"></div>
          </div>
          <div className="discover-loading-recommended-container">
            <div className="discover-loading-recommended-item"></div>
            <div className="discover-loading-recommended-item"></div>
            <div className="discover-loading-recommended-item"></div>
          </div>
        </section>
      </main>

      {/* Footer Skeleton */}
      <footer className="discover-loading-footer">
        <div className="discover-loading-footer-content">
          <div className="discover-loading-footer-item active"></div>
          <div className="discover-loading-footer-item"></div>
          <div className="discover-loading-footer-item"></div>
          <div className="discover-loading-footer-item"></div>
          <div className="discover-loading-footer-item"></div>
        </div>
      </footer>

      {/* Loading Spinner Overlay */}
      {/* <div className="discover-loading-overlay">
        <div className="discover-loading-spinner">
          <div className="discover-loading-spinner-inner"></div>
        </div>
        <div className="discover-loading-text">Loading Discover...</div>
      </div> */}
    </div>
  );
};

export default DiscoverLoadingScreen;
